import { TourSummarySkeleton } from "@/libs/tours-summary/views/TourSummarySkeleton";
import { lazy, Suspense } from "react";

import { useParams } from "react-router-dom";

const TourSummary = lazy(
  () => import("../libs/tours-summary/views/TourSummaryView"),
);

export function TourSummaryPage() {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return null;
  }

  return (
    <Suspense fallback={<TourSummarySkeleton />}>
      <TourSummary tourId={id} />;
    </Suspense>
  );
}
